import {Button, ButtonTypeOptions} from '../buttons';
import React, {useCallback, useState} from 'react';
import {PlayIcon} from '../icons';
import {AccentColorOptions} from 'epic-ue-theme/src/types';
import {BackgroundVideoOptionsArray} from '../../../types';
import {VideoLightbox} from './VideoLightbox';
import {isValidMediaOptions} from '../../../utils';

export interface LightboxButtonProps {
    accentColor?: AccentColorOptions;
    label?: string;
    showPlayIcon?: boolean;
    type?: ButtonTypeOptions;
    mediaOptions?: BackgroundVideoOptionsArray;
}

export const LightboxButton = ({
    accentColor,
    label,
    showPlayIcon,
    type,
    mediaOptions = []
}: LightboxButtonProps): JSX.Element | null => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleLightbox = useCallback(() => {
        setIsOpen(!isOpen);
    }, [setIsOpen, isOpen]);

    if (!label || !isValidMediaOptions(mediaOptions)) return null;

    // the icon doesn't work with the primary type
    let btnType = type || 'tertiary';
    if (type === 'primary' && showPlayIcon) {
        btnType = 'secondary';
    }

    return (
        <div className="lightbox-btn">
            <Button
                type={btnType}
                startIcon={showPlayIcon ? <PlayIcon /> : null}
                color={accentColor}
                onClick={toggleLightbox}>
                {label}
            </Button>

            <VideoLightbox
                mediaOptions={mediaOptions}
                isOpen={isOpen}
                toggleLightbox={toggleLightbox}
                accentColor={accentColor}
            />
        </div>
    );
};
